/* eslint-disable */
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Flag from 'components/Flag';
import COUNTRIES from './countries';
import Select from '../Select';
import { Value } from '../Select/styled';
import { NewCountrySelectStyle } from './styled';

const CountrySelect = ({
  variant,
  placeholder,
  value,
  label,
  onChange,
  formik,
  name,
  excludeCountries = [],
  deselectOption,
  disabled,
  newInputStyle = false,
  ...props
}) => {
  const COUNTRY_OPTIONS = useMemo(
    () =>
      Object.keys(COUNTRIES)
        .filter((c) => !excludeCountries.includes(c))
        .map((country) => ({
          value: country,
          label: COUNTRIES[country]
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [excludeCountries]
  );
  return (
    <Select
      label={label}
      formik={formik}
      value={value}
      onChange={onChange}
      variant={variant}
      name={name}
      options={
        deselectOption
          ? [{ value: undefined, label: deselectOption }, ...COUNTRY_OPTIONS]
          : COUNTRY_OPTIONS
      }
      placeholder={placeholder}
      components={{
        SingleValue: ({ data }) => {
          return (
            <Value variant={variant} data={data}>
              <Flag size={16} code={data.value} />
              {data.label}
            </Value>
          );
        }
      }}
      disabled={disabled}
      newInputStyle={newInputStyle}
      {...props}
    />
  );
};

CountrySelect.propTypes = {
  variant: PropTypes.oneOf(['block', 'light', 'dark']),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.object,
  name: PropTypes.string,
  excludeCountries: PropTypes.array,
  deselectOption: PropTypes.string
};

CountrySelect.defaultProps = {
  variant: 'dark',
  placeholder: 'Select...',
  label: '',
  name: ''
};

export const NewContrySelect = styled(CountrySelect)`
  ${NewCountrySelectStyle}
`;

export default CountrySelect;
